import { useCallback, useState, Dispatch, SetStateAction } from 'react'

// Lightweight global manager for open select id (module-level, testable)
let openSelectId: number | null = null
export const setOpenSelectId = (id: number | null) => { openSelectId = id }
export const getOpenSelectId = () => openSelectId

export interface UseSelectStateReturn {
    selected: string | null
    setSelected: (s: string | null) => void
    open: boolean
    setOpen: (val: boolean) => void
    activeItemIndex: number
    setActiveItemIndex: Dispatch<SetStateAction<number>>
    itemCount: number
    setItemCount: Dispatch<SetStateAction<number>>
    reset: () => void
}

export const useSelectState = (
    value: string | null,
    id?: number,
    onOpenChange?: (v: boolean) => void,
    onSelect?: (v: string | null) => void,
): UseSelectStateReturn => {
    const [open, setOpenState] = useState(false)
    const [activeItemIndex, setActiveItemIndex] = useState<number>(-1)
    const [itemCount, setItemCount] = useState<number>(0)

    const selectId = typeof id === 'number' ? id : Math.floor(Math.random() * 1e9)

    const setOpen = useCallback((val: boolean) => {
        if (val) setOpenSelectId(selectId)
        else if (getOpenSelectId() === selectId) setOpenSelectId(null)
        setOpenState(val)
        onOpenChange?.(val)
    }, [selectId, onOpenChange])

    const reset = useCallback(() => {
        setOpen(false)
        setActiveItemIndex(-1)
    }, [setOpen, setActiveItemIndex])

    return {
        selected: value,
        setSelected: (s) => {
            onSelect?.(s)
        },
        open,
        setOpen,
        activeItemIndex,
        setActiveItemIndex,
        itemCount,
        setItemCount,
        reset,
    }
}

export default useSelectState

